<template>
    <div>
        <v-data-table
            :headers="headers" 
            :items="scoutings"
            :pagination.sync="pagination"
            :loading="tableLoading"
            hide-actions>
            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <!-- <td>{{props.item.PlantName}}</td>
                <td>{{props.item.DivisionName}}</td> -->
                <td>{{props.item.LocationName}}</td>
                <td>{{props.item.Date | formatDate}}</td>
                <td>{{props.item.FruitOnPlants == true ? "Yes": "No" }}</td>
                <td>{{props.item.Closed == true ? "Yes": "No" }}</td>
                <td>{{props.item.ScoutingSpotChecks ? props.item.ScoutingSpotChecks.length : "0"}} / {{ props.item.SpotChecks }}</td>
                <td>{{props.item.Notes}}</td>
                <td>{{props.item.CreatedByName}}</td>
                <td>
                    <v-layout row>
                        <v-flex shrink class="pr-1">
                            <v-btn color="info" small :disabled="!props.item.ScoutingID" block @click="showSummary(props.item)">
                              <v-icon>assignment</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex shrink class="pr-1">                
                            <v-btn color="primary" small :disabled="!props.item.ScoutingID" block @click="editScout(props.item)"><v-icon>edit</v-icon></v-btn>
                        </v-flex>                            
                        <v-flex shrink>
                            <v-btn color="error" small :disabled="!props.item.ScoutingID" block @click="showDeleteDialog(props.item)"><v-icon>delete</v-icon></v-btn>
                        </v-flex>
                    </v-layout>
                </td>
            </template>
        </v-data-table>
        
        <delete-dialog
            :DisplayDialog="showConfirmDeleteImage" 
            :DialogTitle="'Delete Scouting'" 
            :DialogContents="'Are you sure you want to delete this scouting?'"
            @No="showConfirmDeleteImage = false"
            @Yes="deleteScout(deleteItem)">
        </delete-dialog>

        <ScoutingSummaryDialog ref="scoutingSummaryDialog" @editScouting="editScout"></ScoutingSummaryDialog>
    </div>
</template>

<script>
import DeleteDialog from "@/components/generic/YesNoPopup.vue";
import ScoutingSummaryDialog from "./ScoutingSummaryDialog.vue";

export default {
    components: {      
        DeleteDialog,
        ScoutingSummaryDialog
    },
    data() {
        return {
            debug: false,
            showConfirmDeleteImage: false,
            deleteItem: null,
            pagination: {
                page: 1,
                rowsPerPage: -1, // COSTABAU-445 Show all rows
                sortBy: 'Date',
                descending: true
            },
            headers: [
                {
                    text: "Location",
                    value: "LocationName",
                    align: 'left'
                },
                {
                    text: "Date",
                    value: "Date",
                    align: 'left',
                    width: "10px"
                },
                {
                    text: "Fruit on Plants?",
                    value: "FruitOnPlants",
                    align: 'left',
                    width: "10px"
                },
                {
                    text: "Closed",
                    value: "Closed",
                    align: 'left',
                    width: "10px"
                },
                {
                    text: "Spot Checks",
                    value: "SpotCheckCount",
                    align: 'left',
                    width: "10px"
                },
                {
                    text: "Notes",
                    value: "Notes",
                    align: 'left'
                },
                {
                    text: "Created By",
                    value: "CreatedByname",
                    align: 'left'
                },
                {
                    text: "Actions",
                    value: "",
                    align: "left",
                    sortable: false,
                    width: "150px"
                }
            ]
        }
    },
    props: [
        "tableLoading"
    ],
    watch: {
        
    },
    computed: {
        scoutings() {
            let data = this.$store.getters["ScoutStore/getScoutings"](this.selectedPlant, this.selectedDivision, this.selectedLocation);
            return data;
        },
        selectedPlant: {
            get() {
                return this.$store.state.PestAndDiseaseStore.selectedPlant;
            }
        },
        selectedDivision: {
            get() {
                return this.$store.state.PestAndDiseaseStore.selectedDivision;
            }
        },
        selectedLocation: {
            get() {
                return this.$store.state.PestAndDiseaseStore.selectedLocation;
            }
        },
    },
    methods: {
        editScout(scout) {
            this.$emit("editScout", scout);
        },
        async deleteScout(scout) {
            scout.Deleted = true;
            this.showConfirmDeleteImage = false;

            await this.$store.dispatch("ScoutStore/saveScout", { scouting: scout, plantIDs: [this.selectedPlant] });            
            
            this.deleteItem = null;
        },
        showDeleteDialog(scout) {
            this.deleteItem = scout;
            this.showConfirmDeleteImage = true;
        },
        showSummary(scouting) {
            this.$refs.scoutingSummaryDialog.showDialog(scouting);
        },
    },
    async created() {
        
    }
}
</script>

<style>

</style>
